<template>
    <div id="permissions">
        <div v-if="is_show_permission_groups">
            <div class="field">
                <label>權限群組</label>
            </div>
            <div class="fields" style="flex-wrap: wrap;" v-if="permission_groups.length">
                <div class="field"
                    style="margin: 6px;"
                    v-for="permission_group in permission_groups"
                >
                    <div class="ui slider checkbox">
                        <input type="checkbox"
                            :id="permission_group.identity"
                            v-model="permission_group.checked"
                            @click="toggle_permissions($event, permission_group.permission_identities, true)"
                        >
                        <label :for="permission_group.identity"
                            style="position: relative;"
                        >
                            {{ permission_group.name }}
                            <router-link
                                v-if="permission_group.identity"
                                :to="{name: 'edit_permission_group', params: {
                                    identity: permission_group.identity
                                }}"
                                style="font-size:smaller;"
                            >
                                [{{ $t('ui.general.edit') }}]
                            </router-link>
                        </label>
                    </div>
                </div>
            </div>
            <div class="fields" v-else>
                <div class="field"></div>
                <div class="field">目前無任何群組</div>
            </div>
        </div>

        <div class="field" v-if="is_initialized">
            <label>細部權限</label>
            <table class="ui striped table">
                <tbody>
                    <tr
                        v-for="grouped_permission in grouped_permissions"
                        v-if="grouped_permission.permissions.length"
                        >
                        <td>
                            <div class="ui checkbox toggle">
                                <input type="checkbox"
                                    :id="grouped_permission.name"
                                    v-model="grouped_permission.checked"
                                    @click="toggle_permissions(
                                        $event,
                                        grouped_permission.permissions
                                    )"
                                >
                                <label :for="grouped_permission.name">
                                    {{ grouped_permission.name }}
                                </label>
                            </div>
                        </td>

                        <td>
                            <div class="ui horizontal relaxed list">
                                <div class="item" v-for="permission in grouped_permission.permissions">
                                    <div class="ui checkbox">
                                        <input type="checkbox"
                                            :id="'check'+permission.identity"
                                            :value="permission.identity"
                                            v-model="role.permission_identities"
                                        >
                                        <label :for="'check'+permission.identity">
                                            <!-- {{ $t("permissions_table."+permission.name) }} -->
                                            {{ permission.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderRolesPermissionsTable",
    props: {
        is_show_permission_groups: {
            type: Boolean,
            default: true,
        },
        role: Object
    },
    data: function () {
        return {
            is_initialized: false,
            grouped_permissions: [],
            permission_groups:[],
            list: [],
        }
    },
    mounted: function() {
        var that = this;

        that.init();
    },
    watch: {
        role_permission_identities: function() {
            var that = this;

            that.permission_checkbox_switch_permissions_toggle();
        },
        permissions: function() {
            var that = this;

            that.init();
        },
    },
    computed: {
        role_permission_identities: function() {
            return this.role.permission_identities;
        },
        permissions: function() {
            return this.$store.state.provider.roles_module.permissions;
        },
    },
    methods: {
        init: async function() {
            var that = this;

            await that.handle_service_config_menu_name()
            await that.init_grouped_permissions();
            await that.init_permission_groups();
            await that.permission_checkbox_switch_permissions_toggle();
            await new Promise(resolve => {
                that.is_initialized = true;
                resolve();
            });
        },
        handle_service_config_menu_name: function() {
            var that = this;

            that.list = []
            _.forEach(that.$store.state.provider.service_config.menu, function(menu) {
                if (menu.items) {
                    _.forEach(menu.items, function(item) {
                        that.list.push({
                            name: that.handle_list_name_remove_string_s(item.name)
                        })
                    })
                }else {
                    that.list.push({
                        name: that.handle_list_name_remove_string_s(menu.name)
                    })
                }
            });
            return Promise.resolve();
        },
        handle_list_name_remove_string_s: function(name = null) {
            var that = this;
            try {
                if (!name) {
                    throw false
                }

                var match_name = name.match(/(.+)s/i)
                if (match_name) {
                    return match_name[1];
                } else {
                    return name;
                }
            } catch (e) {
                return false;
            }
        },
        init_grouped_permissions: function() {
            var that = this;

            that.grouped_permissions_array = []
            // var lists = [
            //     {"name": "status_prototype"},
            //     {"name": "station"},
            //     {"name": "partition"},
            //     {"name": "customer_node"},
            //     {"name": "asset"},
            //     {"name": "material"},
            //     {"name": "core_waybill"},
            //     {"name": "operation"},
            //     {"name": "permission_group"},
            //     {"name": "role"},
            //     {"name": "staff"},
            //     {"name": "appraisal"},
            //     {"name": "notification"},
            //     {"name": "permissions"},
            //     {"name": "file"},
            //     {"name": "simulate"},
            //     {"name": "dependent"},
            //     {"name": "requested"}
            // ];

            _.map(that.list, function(item) {
                item.checked = false;
                var result = [];

                // if (item.name == "work") {
                //     result.push(_.find(that.permissions, function(permission) {
                //         return permission.name == "api_v1_provider_work"
                //     }))
                // }

                _.forEach(that.permissions, function(permission) {

                    var name = item.name
                    if (name == 'user_log') {
                        name = 'log'
                    }
                    if (name == 'uploader') {
                        name = 'file'
                    }

                    if (permission.name.indexOf(name) != '-1') {
                        result.push(permission)
                        that.grouped_permissions_array.push(permission)
                    }
                })

                item.permissions = _.sortBy(result, [function(value) {
                    return value.name;
                }]);
            })

            that.grouped_permissions = that.list;
            return Promise.resolve();
        },
        init_permission_groups: function() {
            var that = this;

            var result = $.extend(true, [], that.$store.state.provider.roles_module.permission_groups);
            _.map(result, function(obj) {
                obj.checked = false;
            })

            that.permission_groups = result;
            return Promise.resolve();
        },
        // 由 細部權限內 各類群組 切換 群組 開關
        toggle_permissions: function($event, objs, is_array = false) {
            var that = this;

            var result = _.map(objs, function(obj) {
                return obj.identity;
            })

            if (is_array) result = objs;

            var identities = that.role.permission_identities;
            identities = ( !$event.target.checked)
                ? _.pullAll(identities, result)
                : _.concat(identities, result);

            that.role.permission_identities = _.sortBy(_.union(identities));
        },

        // 由 permission 切換 細部權限內 各類群組 開關
        permission_checkbox_switch_permissions_toggle: function() {
            var that = this;

            _.map(that.grouped_permissions, function(grouped_permission) {
                var self_permissions_all_checked = [];

                _.map(grouped_permission.permissions, function(permission) {
                    self_permissions_all_checked.push(
                        _.findLast(that.role.permission_identities, function(n) {
                            return n == permission.identity;
                        })
                    );
                })

                var result = _.remove(self_permissions_all_checked, _.isUndefined);
                if (result.length == 0) {
                    grouped_permission.checked = true;
                } else {
                    grouped_permission.checked = false;
                }
            })

            if (that.is_show_permission_groups) {
                that.toggle_permission_switch_toggle_permission_groups()
            };

            return Promise.resolve();
        },

        // 由 permission 切換 權限群組 開關
        toggle_permission_switch_toggle_permission_groups: function() {
            var that = this;

            _.map(that.permission_groups, function(permission_group) {
                var self_permission_group_all_checked = [];

                _.map(permission_group.permission_identities, function(identity) {
                    self_permission_group_all_checked.push(
                        _.findLast(that.role.permission_identities, function(n) {
                            return n == identity;
                        })
                    );
                })

                var result = _.remove(self_permission_group_all_checked, _.isUndefined);
                if (result.length == 0) {
                    permission_group.checked = true;
                } else {
                    permission_group.checked = false;
                }
            })
        },
    },
}
</script>
<style lang="scss">
    @import "../.assets/stylesheets/permissions_table.scss";
</style>
